import { Link } from "react-router-dom";
import DocNavigation from "../../components/DocNavigation";

export default function Integration() {
    return (
        <section className="space-y-10">

            {/* HEADER */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    Integration
                </h1>

                <p className="text-md text-slate-600 max-w-3xl">
                    Integration enables EventFlow to communicate seamlessly with your
                    existing systems and external platforms.
                </p>

                <section className="bg-white border-l border-[#C9A24E] p-4 mt-4">
                    <h2 className="text-lg font-semibold mb-2">Overview</h2>
                    <p className="text-sm text-slate-600">
                        Integrated systems eliminate duplication and ensure data consistency.
                    </p>
                </section>
            </section>

            {/* WHY */}
            <section className="bg-slate-100 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-3">
                    Why Integration Is Important
                </h2>

                <p className="text-md text-slate-600 max-w-3xl mb-4">
                    Without integration, data silos form and manual work increases.
                    EventFlow integrations ensure smooth operational flow.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-2">
                    <li>Reduces manual data entry</li>
                    <li>Ensures real-time updates</li>
                    <li>Improves reporting accuracy</li>
                    <li>Connects operational and financial systems</li>
                </ul>
            </section>

            {/* SUPPORTED */}
            <section className="bg-white border border-slate-200 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-4">
                    Supported Integrations
                </h2>

                <ul className="list-disc pl-5 text-slate-600 space-y-2">
                    <li>Accounting & finance systems</li>
                    <li>Payment gateways</li>
                    <li>Online booking platforms</li>
                    <li>SMS & email services</li>
                    <li>Custom APIs</li>
                </ul>
            </section>

            {/* VALUE */}
            <section className="bg-slate-100 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-3">
                    Business Value
                </h2>

                <p className="text-md text-slate-600 max-w-3xl">
                    Integration ensures EventFlow works as a unified ecosystem rather than
                    a standalone tool.
                </p>
            </section>
{/* 
            <section className="border-t pt-8 mt-12">
                <p className="text-slate-600">
                    Next, learn about{" "}
                    <Link to="/docs/data-migration" className="font-medium text-[#C9A24E]">
                        Data Migration
                    </Link>.
                </p>
            </section> */}
     <DocNavigation
                previous={{
                    title: "Customization",
                    link: "/docs/customization"
                }}
                next={{
                    title: "Data Migration",
                    link: "/docs/data-migration"
                }}
            />

        </section>
    );
}
